export default "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='0'%20height='0'%20viewBox='0%200%200%200'%3e%3c/svg%3e"